module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "prayer"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_vm._v("  Prayers ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Arti and Prayers at Samadhi daily at 7:00 AM and 7:00 PM")])]), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Universal Prayer (Master’s Prayer)")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('p', [_vm._v("O Parvardigar — the Preserver and Protector of all!")]), _vm._v(" "), _c('p', [_vm._v("You are without Beginning, and without End,")]), _vm._v(" "), _c('p', [_vm._v("Non-dual, beyond comparison, and none\r\n\t\t\t\t\tcan measure You.")]), _vm._v(" "), _c('p', [_vm._v("You are without colour, without expression,\r\n\t\t\t\t\twithout form, and without attributes.")]), _vm._v(" "), _c('p', [_vm._v("You are unlimited and unfathomable,\r\n\t\t\t\t\tbeyond imagination and conception,\r\n\t\t\t\t\teternal and imperishable.")]), _vm._v(" "), _c('p', [_vm._v("You are indivisible; and none can see You,\r\n\t\t\t\t\tbut with Eyes Divine.")]), _vm._v(" "), _c('p', [_vm._v("You always were, You always are, and\r\n\t\t\t\t\tYou always will be;")]), _vm._v(" "), _c('p', [_vm._v("You are everywhere, You are in everything;\r\n\t\t\t\t\tand You are also beyond everywhere\r\n\t\t\t\t\tand beyond everything.")]), _vm._v(" "), _c('p', [_vm._v("You are in the firmament and in the depths;\r\n\t\t\t\t\tYou are manifest and unmanifest, on\r\n\t\t\t\t\tall planes and beyond all planes.")]), _vm._v(" "), _c('p', [_vm._v("You are in the three worlds, and also\r\n\t\t\t\t\tbeyond the three worlds;")]), _vm._v(" "), _c('p', [_vm._v("You are imperceptible and independent.")]), _vm._v(" "), _c('p', [_vm._v("You are the Creator, the Lord of lords,\r\n\t\t\t\t\tthe knower of all minds and hearts;")]), _vm._v(" "), _c('p', [_vm._v("You are omnipotent and omnipresent.")]), _vm._v(" "), _c('p', [_vm._v("You are Knowledge Infinite, Power Infinite,\r\n\t\t\t\t\tand Bliss Infinite.")]), _vm._v(" "), _c('p', [_vm._v("You are the Ocean of Knowledge, all-knowing,\r\n\t\t\t\t\tinfinitely knowing, the Knower of the past,\r\n\t\t\t\t\tthe present, and the future, and You are\r\n\t\t\t\t\tKnowledge Itself.")]), _vm._v(" "), _c('p', [_vm._v("You are all-merciful and eternally benevolent;")]), _vm._v(" "), _c('p', [_vm._v("You are the Soul of souls, the One with\r\n\t\t\t\t\tinfinite attributes.")]), _vm._v(" "), _c('p', [_vm._v("You are the Trinity of Truth, knowledge, and\r\n\t\t\t\t\tBliss,")]), _vm._v(" "), _c('p', [_vm._v("You are the Source of Truth, the Ocean of Love;")]), _vm._v(" "), _c('p', [_vm._v("You are the Ancient One, the Highest of the High;\r\n\t\t\t\t\tYou are Prabhu and Parameshwar, You are the\r\n\t\t\t\t\tBeyond-God, and the Beyond-Beyond God also,\r\n\t\t\t\t\tYou are Parabrahma, Allah, Elahi, Yezdan,\r\n\t\t\t\t\tAhuramazda, and God the Beloved.")]), _vm._v(" "), _c('p', [_vm._v("You are named Ezad — the only One\r\n\t\t\t\t\tworthy of worship.")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Repentance Prayer")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('p', [_vm._v("We repent O God most merciful, for all our sins;")]), _vm._v(" "), _c('p', [_vm._v("For every thought that was false or unjust or unclean;")]), _vm._v(" "), _c('p', [_vm._v("For every word spoken that ought not to have been spoken;")]), _vm._v(" "), _c('p', [_vm._v("For every deed done that ought not to have been done.")]), _vm._v(" "), _c('p', [_vm._v("We repent for every deed and word and thought")]), _vm._v(" "), _c('p', [_vm._v("Inspired by selfishness;")]), _vm._v(" "), _c('p', [_vm._v("And for every deed and word and thought inspired by hatred.")]), _vm._v(" "), _c('p', [_vm._v("We repent most specially for every lustful thought,")]), _vm._v(" "), _c('p', [_vm._v("And every lustful action;")]), _vm._v(" "), _c('p', [_vm._v("For every lie; for all hypocrisy;")]), _vm._v(" "), _c('p', [_vm._v("For every promise given, but not fulfilled")]), _vm._v(" "), _c('p', [_vm._v("And for all slander and backbiting.")]), _vm._v(" "), _c('p', [_vm._v("Most specially also, we repent for every action")]), _vm._v(" "), _c('p', [_vm._v("That has brought ruin to others;")]), _vm._v(" "), _c('p', [_vm._v("For every word and deed that has given others pain;")]), _vm._v(" "), _c('p', [_vm._v("And for every wish that pain should befall others.")]), _vm._v(" "), _c('p', [_vm._v("In your unbounded mercy, we ask you to forgive us, O God,")]), _vm._v(" "), _c('p', [_vm._v("For all these sins committed by us;")]), _vm._v(" "), _c('p', [_vm._v("And to forgive us for our constant failures")]), _vm._v(" "), _c('p', [_vm._v("To think and speak and act according to your will.")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Beloved God Prayer")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3"
  }, [_c('p', [_vm._v("Beloved God, help us all to love You more and more, and more and more and still yet more, till we become worthy of union with You; and help us all to hold fast to Baba’s daaman till the very end.")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e8b4caf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prayers.vue
// module id = 313
// module chunks = 1